import React from 'react';
import { Redirect } from 'react-router';

import { locationsURL } from '@root/components/locations/routes';

export const City = () => {
  return <Redirect to={locationsURL()} />;
};
